module.exports = __webpack_public_path__ + "static/sv-a64aa0bf3275522da3aec044d98e4968.svg";